import * as React from "react";
import "./RequestsCardInner.scss";

// Components
import { IonSpinner } from "@ionic/react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

// Utilities
import moment from "moment";

export default function RequestsCardInner({ stage, loading }: { stage: any; loading: boolean }) {
  const { t } = useTranslation();
  return (
    <div className="registration-stages__column__users registration-stages__column__users--table">
      {loading ? (
        <IonSpinner name="dots" />
      ) : (
        <table>
          <thead>
            <tr className="registration-stages__column__users--table__header">
              <th>{t("name")}</th>
              <th>{t("date")}</th>
              <th>{t("request")}</th>
            </tr>
          </thead>
          <tbody>
            {stage.users.map((user: any) =>
              user?.revisions
                // Only display unnaproved/pending requests
                .filter((revision: any) => revision.status === "pending")
                .map((revision: any, key: any) => (
                  <tr key={key}>
                    <td>
                      {/* Athlete name */}
                      <Link to={`/admin/members/${user.id}`}>{user.member?.nickname || `${t("member")} ${user.id}`}</Link>
                    </td>
                    {/* Date requested */}
                    <td>{moment(revision.created_at).format("D MMMM YYYY")}</td>
                    {/* Request change */}
                    <td>{Object.keys(revision.data)[0].replace("_", " ") + (revision.data.length > 1 ? "+ more" : "")}</td>
                  </tr>
                )),
            )}

            {stage.users.length === 0 && <span className="registration-stages__message registration-stages__message--no-results">{t("noUsersToShow")}</span>}
          </tbody>
        </table>
      )}
    </div>
  );
}
